<form [formGroup]="form" (ngSubmit)="onSubmit()" class="update-password p-5">
  <h4 class="mb-4 text-left font-weight-light">
    <span class="font-weight-bold">Update Your Password</span>
  </h4>

  <div class="form-group form-row">
    <div class="col-12">
      <label for="password">New Password</label>
    </div>
    <div class="col-12">
      <p-password
        name="password"
        formControlName="password"
        [toggleMask]="true"
      ></p-password>

      <small class="text-danger">{{ "Error" | translate }}</small>
    </div>
  </div>
  <div class="form-group form-row">
    <div class="col-12">
      <label for="password">Repeat Password</label>
    </div>
    <div class="col-12">
      <p-password
        name="confirmPassword"
        formControlName="confirmPassword"
        [toggleMask]="true"
      ></p-password>

      <small class="text-danger">{{ "Match Error" | translate }}</small>
    </div>
  </div>

  <button
    type="submit"
    class="btn btn-md btn-warning btn-block text-uppercase mt-3"
  >
    {{ "Confirm" | translate }}
  </button>
</form>
